export default __webpack_public_path__ + "1ac33a0.png";